module.exports = __webpack_public_path__ + "ofis 9.jpg?3f83f7dbb990e85d93df5d8abb03641c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis 9.jpg
// module id = 356
// module chunks = 0